/**
 * Value Accessor Service
 */
import { EventEmitter, Injectable } from '@angular/core';

import type { ControlValueAccessor } from '@angular/forms';

const noop = (): void => {};

@Injectable()
export class ValueAccessorService<T = string> implements ControlValueAccessor {
  public modelWrites: EventEmitter<T> = new EventEmitter<T>();
  private _model: T;
  private onChanged: (m: T) => void;
  private onTouched: () => void = noop;

  public onBlur(): void {
    this.onTouched();
  }

  public writeValue(value: T): void {
    this._model = value;
    this.modelWrites.emit(value);
  }

  public registerOnChange(fn: () => void): void {
    this.onChanged = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public get model(): T {
    return this._model;
  }

  // tslint:disable-next-line
  public set(value: T): void {
    this._model = value;

    if (this.onChanged) {
      this.onChanged(this._model);
    }
  }
}
